import Icon, { IconType } from 'components/Icon';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setSidebarVisible, setSidebarHovered } from 'redux/mode/actions';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';

interface SidebarToggleProps {
	isFloating?: boolean;
}

const SidebarToggle = ({ isFloating = false }: SidebarToggleProps) => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const { sidebarVisible, sidebarDocked, isMobile } = useSelector((r: RootReducer) => {
		return {
			sidebarVisible: r.mode.sidebarVisible,
			sidebarDocked: r.mode.sidebarDocked,
			isMobile: selectIsMobile(r.mode),
		};
	}, shallowEqual);

	const onClick = () => {
		if (isMobile) {
			dispatch(setSidebarVisible(!sidebarVisible));
		}
	};

	const onMouseEnter = () => {
		if (!isMobile && !sidebarDocked) {
			dispatch(setSidebarHovered(true));
		}
	};

	const onMouseLeave = () => {
		if (!isMobile && !sidebarDocked) {
			dispatch(setSidebarHovered(false));
		}
	};

	return (
		<S.Base
			isMobile={isMobile}
			isFloating={isFloating}
			onClick={isMobile ? onClick : undefined}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<Icon
				type={IconType.MOONCHILD}
				width={isMobile ? 28 : 22}
				height={isMobile ? 28 : 22}
				color={theme.blue[900]}
			/>
		</S.Base>
	);
};

export default SidebarToggle;
